














import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { routeName } from '@/constants/route.constants';
import { UNKNOWN_VETERINARIAN_ID } from '@/constants/anonymous-registration.constants';
import CustomerModule, {
  CUSTOMERS_MODULE_NAME
} from '@/store/modules/customer.module';
import RegisteredTagModule, {
  REGISTERED_TAG_MODULE_NAME
} from '@/store/modules/registered-tag.module';
import AuthenticationModule from '@/store/modules/authentication.module';
import { mapState } from 'vuex';
import { RegisteredTag } from '@/models/DTO/registered-tag/registered-tag.model';
import { Customer } from '@/models/DTO/customer/customer.model';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const paypal: any;
const PayPalButton = paypal.Buttons.driver('vue', Vue);

const registeredTagModule: RegisteredTagModule = getModule(
  RegisteredTagModule,
  store
);

const customerModule: CustomerModule = getModule(CustomerModule, store);

const authenticationModule: AuthenticationModule = getModule(
  AuthenticationModule,
  store
);

@Component({
  components: {
    'paypal-buttons': PayPalButton
  },
  computed: {
    ...mapState(REGISTERED_TAG_MODULE_NAME, {
      currentRegisteredTag: 'currentRegisteredTag',
      errorTagResponse: 'errorResponse'
    }),
    ...mapState(CUSTOMERS_MODULE_NAME, ['currentCustomer', 'errorResponse'])
  }
})
export default class PayPalComponent extends Vue {
  @Prop({
    required: true
  })
  public code: string;

  @Prop({
    required: true
  })
  public customer: Customer;

  public currentRegisteredTag: RegisteredTag | null;
  public currentCustomer: Customer | null;
  public errorResponse: BaseAPIErrorModel | null;
  public errorTagResponse: BaseAPIErrorModel | null;
  public orderDate: Date;
  public cost = 2.99;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createOrder(data: any, actions: any): any {
    return actions.order.create({
      // eslint-disable-next-line @typescript-eslint/camelcase
      purchase_units: [
        {
          description: `Tag Registration ${this.code}`,
          amount: {
            value: this.cost
          }
        }
      ]
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async onApprove(data: any, actions: any): Promise<any> {
    const orderData = await actions.order.capture();

    this.orderDate = orderData.create_time;

    if (orderData.status === 'COMPLETED') {
      this.onConfirmationOfPayment();
    } else {
      this.$toasted.error(
        'The payment method provided has failed. Please make sure the payment details are correct and that your account has sufficient funds, then please try again.',
        { duration: 10000 }
      );
    }
  }

  public onError(err: unknown) {
    console.log(err);
  }

  public async onConfirmationOfPayment(): Promise<void> {
    // Create customer first and then register the tag
    await authenticationModule.acceptTermsAction(true);
    // [this.customer] is the customer object sent via a Prop from the owner-form.component.
    await customerModule.registerCustomerIfNeededAction({ ...this.customer });

    // [this.currentCustomer] retrieves the customer created after registration.
    if (!this.errorResponse && this.currentCustomer) {
      await registeredTagModule.addNewTagAction({
        code: this.code,
        customerId: this.currentCustomer.id,
        veterinarianOfficeId: UNKNOWN_VETERINARIAN_ID
      });

      if (!this.errorTagResponse && this.currentRegisteredTag) {
        await registeredTagModule.orderDetailsAction({
          cost: this.cost.toString(),
          tag: this.code,
          orderDate: new Date()
        });

        this.$router.replace({ name: routeName.public.paymentConfirmation });
      }
    }
  }
}
